import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from './store';
import { OeAppPersonService } from './oe-app-person.service';

export class ChatBotNotification {
  constructor(
    public id: number,
    public text?: string,
    public read?: boolean   
  ) {}
}

@Injectable()
export class ChatBotNotificationService extends Store<ChatBotNotification[]> {
  public notifications$ = this.state$;
  public unreadNotifications$ = this.notifications$.pipe(
    map((notifications) => notifications.filter(notification => !notification.read))
  );

  constructor(
    private oeAppPersonService: OeAppPersonService,
  ) {
    super([]);
    this.getNotifications$().subscribe(notifications => this.setState(notifications));
  }

  private getNotifications$(): Observable<ChatBotNotification[]> {
    // TODO fetch notifications from the server
    return of([new ChatBotNotification(1, '', this.oeAppPersonService.hasSeenCopilotOnboarding)]);
  }

  public markAsRead$(notificationId : ChatBotNotification['id']): Observable<ChatBotNotification> {
    const notification = this.state.find(notification => notification.id === notificationId);
    if (notification) {
      notification.read = true;
      this.setState(this.state);
    }
    // TODO persist changes to the server
    return of(notification);
  }
}


// WEBPACK FOOTER //
// ./ts/app/shared/chat-bot-notification.service.ts